<div class="clinical-studies-wrapper container-fluid">
    <div class="container-xxxl">
        <div class="row d-print-block">
            <!-- Left Column: Main Articles -->
            <div class="col-12 col-lg-6 pt-4 pt-lg-5 pb-5 pb-lg-0 left-column d-print-block">
                <div *ngFor="let article of mainKAs; last as isLast" [ngClass]="{ 'mb-4 mb-lg-5': !isLast }">
                    <h3 class="fs-5 fs-lg-3 text-maroon mb-4" embeddedHTML [innerHTML]="article.title"></h3>
                    <clamper class="description fs-6 fs-lg-18 text-link" [maxLines]="mainArticleMaxLines" [text]="article.bodyText"></clamper>
                </div>
            </div>

            <!-- Spacing Column (Desktop only) -->
            <div class="col-1 d-none d-lg-block d-print-none"></div>

            <!-- Right Column: Info Articles -->
            <div class="col-12 col-lg-5 right-side bg-lightblue py-4 py-lg-5 px-0 px-lg-5 d-print-block">
                <div class="px-4 px-lg-0">
                    <div *ngFor="let article of infoKAs; last as isLast" [ngClass]="{ 'mb-4 mb-lg-5': !isLast }">
                        <h3 class="fs-5 fs-lg-3 text-blue mb-4" embeddedHTML [innerHTML]="article.title"></h3>
                        <p class="text-link fs-6 fs-lg-18 mb-0" embeddedHTML [innerHTML]="article.bodyText"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
